import { useVModel } from '@vueuse/core';
import { VDialog, VNavigationDrawer } from 'vuetify/lib/components';
import AppToolbar from '~/core/components/AppToolbar/AppToolbar.vue';
import AppSmartBanner from '~/core/components/AppSmartBanner/AppSmartBanner.vue';
import useMainStore from '~/stores/useMainStore';
export default defineComponent({
  name: 'BaseFullscreenDialog',
  components: {
    AppSmartBanner: AppSmartBanner,
    AppToolbar: AppToolbar
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    backTo: {
      type: Boolean,
      default: false
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    borderlessTitle: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    pageBorder: {
      type: Boolean,
      default: false
    },
    fixedToolbar: {
      type: Boolean,
      default: false
    },
    toolbarAppendIcon: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    showSmartBanner: {
      type: Boolean,
      default: false
    },
    persistentScroll: {
      type: Boolean,
      default: false
    },
    preventFromClose: {
      type: Boolean,
      default: false
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click:prepend-icon', 'click:append-icon', 'input'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var mainStore = useMainStore();
    var isActive = useVModel(props);
    watch(isActive, function (val, prev) {
      if (val) {
        mainStore.incOverlaysCount();
      } else if (prev && !val) {
        mainStore.decOverlaysCount();
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(function () {
      if (isActive.value) {
        mainStore.overlaysCount = 0;
      }
    });
    function handleClickClose() {
      emit('click:prepend-icon');
      if (props.preventFromClose) {
        return;
      }
      emitInput(false);
    }
    function emitClickAppendIcon() {
      emit('click:append-icon');
    }
    function emitInput(ev) {
      isActive.value = ev;
    }
    return {
      isActive: isActive,
      handleClickClose: handleClickClose,
      emitClickAppendIcon: emitClickAppendIcon,
      emitInput: emitInput,
      VDialog: VDialog,
      VNavigationDrawer: VNavigationDrawer
    };
  }
});